import * as React from 'react';

export const chevronUp = (): React.ReactElement => (
  <path d="M1.5 11L8 5l6.5 6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
);

export default chevronUp;
